const PdfIcon = () => {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5031 9.2496H14.0199V0.503901C14.0199 0.225579 13.7975 0 13.523 0H3.78508C3.64152 0 3.50508 0.0629316 3.41072 0.172558L0.122577 3.99285C0.0435091 4.08467 0 4.20236 0 4.32419V17.4961C0 17.7744 0.22246 18 0.496932 18H13.523C13.7975 18 14.0199 17.7744 14.0199 17.4961V16.0528H15.5031C15.7775 16.0528 16 15.8272 16 15.5489V9.7535C16 9.47518 15.7775 9.2496 15.5031 9.2496ZM15.0061 15.045H4.34208V10.2574H15.0062L15.0061 15.045ZM3.28814 1.84758V3.82029H1.59018L3.28814 1.84758ZM13.0261 16.9922H0.993864V4.8281H3.78508C4.05955 4.8281 4.28201 4.60252 4.28201 4.32419V1.0078H13.0261V9.2496H3.84515C3.57068 9.2496 3.34822 9.47518 3.34822 9.7535V15.5489C3.34822 15.8272 3.57068 16.0528 3.84515 16.0528H13.0261V16.9922Z"
        fill="#E56353"
      />
      <path
        d="M7.25727 4.55933L7.57139 3.07025H7.57895L7.89307 4.55933H8.43815L9.01713 2.51758H8.47211L8.15805 3.98359H8.15043L7.84768 2.51758H7.31403L7.03017 3.98359H7.02261L6.70849 2.51758H6.14453L6.71225 4.55933H7.25727Z"
        fill="#E56353"
      />
      <path
        d="M9.88756 4.33788H10.7367C11.0112 4.33788 11.2336 4.1123 11.2336 3.83398C11.2336 3.55566 11.0112 3.33008 10.7367 3.33008H9.88756C9.61308 3.33008 9.39062 3.55566 9.39062 3.83398C9.39062 4.1123 9.61308 4.33788 9.88756 4.33788Z"
        fill="#E56353"
      />
      <path
        d="M10.8031 5.22656H6.6981C6.42363 5.22656 6.20117 5.45214 6.20117 5.73046C6.20117 6.00878 6.42363 6.23436 6.6981 6.23436H10.8031C11.0776 6.23436 11.3 6.00878 11.3 5.73046C11.3 5.45214 11.0776 5.22656 10.8031 5.22656Z"
        fill="#E56353"
      />
      <path
        d="M10.8031 7.12695H6.6981C6.42363 7.12695 6.20117 7.35253 6.20117 7.63085C6.20117 7.90918 6.42363 8.13475 6.6981 8.13475H10.8031C11.0776 8.13475 11.3 7.90918 11.3 7.63085C11.3 7.35253 11.0776 7.12695 10.8031 7.12695Z"
        fill="#E56353"
      />
      <path
        d="M6.22467 11.3118C6.22467 11.1989 6.31976 11.0996 6.46442 11.0996H7.32008C7.86572 11.0996 8.29557 11.3795 8.29557 12.1379V12.1605C8.29557 12.9189 7.84914 13.2078 7.27873 13.2078H6.86949V14.1829C6.86949 14.3274 6.70829 14.3996 6.54705 14.3996C6.38581 14.3996 6.22461 14.3274 6.22461 14.1829L6.22467 11.3118ZM6.86949 11.7135V12.6661H7.27873C7.51022 12.6661 7.65075 12.5216 7.65075 12.2146V12.165C7.65075 11.858 7.51022 11.7136 7.27873 11.7136H6.86949V11.7135Z"
        fill="#E56353"
      />
      <path
        d="M9.92203 11.0996C10.5041 11.0996 10.9596 11.3885 10.9596 12.165V13.3342C10.9596 14.1107 10.5041 14.3996 9.92203 14.3996H9.17549C9.00254 14.3996 8.88867 14.3003 8.88867 14.1875V11.3118C8.88867 11.1989 9.00254 11.0996 9.17549 11.0996H9.92203V11.0996ZM9.54665 11.7135V13.7856H9.92203C10.1582 13.7856 10.3016 13.6411 10.3016 13.3342V12.165C10.3016 11.858 10.1582 11.7136 9.92203 11.7136H9.54665V11.7135Z"
        fill="#E56353"
      />
      <path
        d="M11.5508 11.3163C11.5508 11.1718 11.7032 11.0996 11.8556 11.0996H13.411C13.559 11.0996 13.6217 11.2576 13.6217 11.4021C13.6217 11.5691 13.5455 11.7136 13.411 11.7136H12.2501V12.4765H12.9269C13.0614 12.4765 13.1376 12.6074 13.1376 12.7519C13.1376 12.8738 13.0749 13.0182 12.9269 13.0182H12.2501V14.1829C12.2501 14.3274 12.0753 14.3996 11.9004 14.3996C11.7256 14.3996 11.5508 14.3274 11.5508 14.1829V11.3163H11.5508Z"
        fill="#E56353"
      />
    </svg>
  );
};

export default PdfIcon;
